import React from 'react';
import QSHub from '../../components/qs/QSHub';

export default function QualityIntelligence() {
  return <QSHub domain="QUALITY" />;
}
